import { Grid } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';

import { makeSelectWhoami } from 'containers/Auth_old/selectors';
import FountainLogo from 'images/fountain-logo.svg';

const GlobalNavLogo = () => {
  const { accountSlug } = useParams();
  const openingsPath = `/${accountSlug}/openings`;
  const whoami = useSelector(makeSelectWhoami());
  const theme = useTheme();

  // Hide Fountain logo when unified navigation is enabled
  // Default to enabled if account_unified_auth is true, unless explicitly excluded
  const shouldHideLogo = Boolean(
    whoami?.account_unified_auth &&
    !whoami?.feature_flags?.['unified-navigation-exclusion'],
  );

  if (shouldHideLogo) {
    return null;
  }

  return (
    <Grid item style={{ marginRight: theme.spacing(3) }}>
      <Link to={openingsPath} data-testid="navbar-logo">
        <img src={FountainLogo} alt="fountain logo" />
      </Link>
    </Grid>
  );
};

export default GlobalNavLogo;
